module.exports = __webpack_public_path__ + "static/media/icon-empty-service-so.e5ca8840.svg";